module.exports = __webpack_public_path__ + "img/arg.3036121f.svg";